(function () {
  const RECENT_KEY = 'deusdream:recent-products:v1';
  const RECENT_LIMIT = 10;
  const RECENT_VISIBLE = 4;
  const RECENT_TTL = 1000 * 60 * 60 * 24 * 30;
  const URUGUAY_TIME_ZONE = 'America/Montevideo';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function moneyNode(className, value, label) {
    const node = document.createElement('span');
    node.className = className;
    node.textContent = value;
    if (label) node.setAttribute('aria-label', label + ' ' + value);
    return node;
  }

  function updateCardPrice(card, trigger) {
    const price = trigger.dataset.price;
    if (!price) return;

    const priceContainer = card.querySelector("product-price [ref='priceContainer']");
    if (!(priceContainer instanceof HTMLElement)) return;

    const comparePrice = trigger.dataset.comparePrice || '';
    const onSale = trigger.dataset.onSale === 'true' && comparePrice;
    const fragment = document.createDocumentFragment();

    if (onSale) {
      fragment.append(
        moneyNode('price-item__group price', price, 'Precio de oferta'),
        moneyNode('price-item__group price-item--regular compare-at-price', comparePrice, 'Precio anterior')
      );
    } else {
      fragment.append(moneyNode('price', price, 'Precio'));
    }

    priceContainer.replaceChildren(fragment);
    priceContainer.classList.toggle('dd-price-container--sale', Boolean(onSale));

    const installment = card.querySelector('[data-dd-installment] strong, .dd-card-details__installments strong');
    if (installment && trigger.dataset.installmentLabel) {
      installment.textContent = trigger.dataset.installmentLabel;
    }
  }

  function updateCardLinks(card, url) {
    if (!url) return;
    const selectors = [
      "a[ref='productCardLink']",
      "a[ref='productTitleLink']",
      '.card-gallery > a.contents',
      '.dd-cover-card__gallery > a.contents',
      '.dd-card-details__stock',
    ];

    card.querySelectorAll(selectors.join(',')).forEach((link) => {
      if (link instanceof HTMLAnchorElement) link.href = url;
    });
  }

  function updateCardImage(card, trigger) {
    const source = trigger.dataset.imageSrc;
    if (!source) return;

    const image = card.querySelector(
      '.dd-cover-card__gallery img.product-media__image, .card-gallery img.product-media__image, .card-gallery img'
    );
    if (!(image instanceof HTMLImageElement)) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source;
    if (trigger.dataset.imageAlt) image.alt = trigger.dataset.imageAlt;
  }

  function selectVisualVariant(trigger) {
    const card = trigger.closest('product-card');
    if (!(card instanceof HTMLElement)) return;

    card.querySelectorAll('[data-dd-card-visual]').forEach((option) => {
      const selected = option === trigger;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    updateCardImage(card, trigger);
    updateCardPrice(card, trigger);
    updateCardLinks(card, trigger.dataset.productUrl || '');
    runMicroAnimation(trigger, 'dd-micro-variant-selected', 420);
    runMicroAnimation(card.querySelector('product-price'), 'dd-micro-content-change', 420);
    runMicroAnimation(card.querySelector('.product-media__image'), 'dd-micro-media-change', 420);
  }

  function installVisualVariantControls() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-dd-card-visual]');
      if (!(trigger instanceof HTMLButtonElement)) return;
      event.preventDefault();
      event.stopPropagation();
      selectVisualVariant(trigger);
    });
  }

  function uruguayTime() {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: URUGUAY_TIME_ZONE,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    });
    const parts = {};
    formatter.formatToParts(new Date()).forEach((part) => {
      if (part.type !== 'literal') parts[part.type] = part.value;
    });

    return {
      weekday: parts.weekday,
      hour: Number(parts.hour || 0),
      minute: Number(parts.minute || 0),
      second: Number(parts.second || 0),
    };
  }

  function dispatchState(cutoffHour = 13) {
    const now = uruguayTime();
    const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
    const isWeekday = weekdays.includes(now.weekday);
    const elapsed = now.hour * 3600 + now.minute * 60 + now.second;
    const normalizedCutoff = Math.min(23, Math.max(0, Number(cutoffHour) || 0));
    const cutoff = normalizedCutoff * 3600;
    const cutoffLabel = `${String(normalizedCutoff).padStart(2, '0')}:00`;

    if (isWeekday && elapsed < cutoff) {
      const remainingMinutes = Math.max(1, Math.ceil((cutoff - elapsed) / 60));
      const hours = Math.floor(remainingMinutes / 60);
      const minutes = remainingMinutes % 60;
      const duration = hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`;
      return {
        today: true,
        duration,
        nextLabel: 'hoy',
        cutoffLabel,
        heading: 'Despachamos hoy',
        detail: `Pedí dentro de ${duration}`,
        badge: `Quedan ${duration}`,
      };
    }

    let nextLabel = 'el próximo día hábil';
    if (now.weekday === 'Mon' || now.weekday === 'Tue' || now.weekday === 'Wed' || now.weekday === 'Thu') {
      nextLabel = 'mañana';
    } else if (now.weekday === 'Fri' || now.weekday === 'Sat' || now.weekday === 'Sun') {
      nextLabel = 'el lunes';
    }

    return {
      today: false,
      duration: '',
      nextLabel,
      cutoffLabel,
      heading: `Próximo despacho: ${nextLabel}`,
      detail: 'Los pedidos nuevos salen el siguiente día hábil',
      badge: `Corte ${cutoffLabel}`,
    };
  }

  function dispatchTemplate(template, fallback, state) {
    const value = typeof template === 'string' ? template : fallback;
    return String(value || '')
      .replace(/\[tiempo\]/gi, state.duration)
      .replace(/\[d[ií]a\]/gi, state.nextLabel)
      .replace(/\[corte\]/gi, state.cutoffLabel)
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function setDispatchText(element, value) {
    if (!element) return;
    element.textContent = value;
    const wrapper = element.matches('[data-dd-dispatch-heading]') ? element.closest('p') : element;
    if (wrapper instanceof HTMLElement) wrapper.hidden = !value;
  }

  function renderDispatchBanner() {
    document.querySelectorAll('[data-dd-dispatch-banner]').forEach((banner) => {
      if (!(banner instanceof HTMLElement)) return;
      const state = dispatchState(banner.dataset.ddCutoffHour || 13);
      const stateName = state.today ? 'Today' : 'Next';
      const heading = banner.querySelector('[data-dd-dispatch-heading]');
      const detail = banner.querySelector('[data-dd-dispatch-detail]');
      const badge = banner.querySelector('[data-dd-dispatch-badge]');
      setDispatchText(
        heading,
        dispatchTemplate(banner.dataset[`dd${stateName}Heading`], state.heading, state)
      );
      setDispatchText(
        detail,
        dispatchTemplate(banner.dataset[`dd${stateName}Detail`], state.detail, state)
      );
      setDispatchText(
        badge,
        dispatchTemplate(banner.dataset[`dd${stateName}Badge`], state.badge, state)
      );
      banner.dataset.state = state.today ? 'today' : 'next';
    });
  }

  function renderProductDispatch(state) {
    const cards = document.querySelectorAll('.product-information .dd-envio');
    cards.forEach((deliveryCard) => {
      if (deliveryCard.closest('.dd-wholesale, .ddwp-product')) return;
      if (deliveryCard.dataset.ddDispatchReady !== 'true' && !/13:00|env[ií]o en el d[ií]a/i.test(deliveryCard.textContent || '')) return;

      const icon = deliveryCard.querySelector('.dd-envio-icono');
      const copy = document.createElement('span');
      copy.className = 'dd-dispatch-pdp';
      const heading = document.createElement('strong');
      const detail = document.createElement('small');
      heading.textContent = state.heading;
      detail.textContent = state.detail;
      copy.append(heading, document.createElement('br'), detail);

      deliveryCard.replaceChildren();
      if (icon) deliveryCard.append(icon);
      deliveryCard.append(copy);
      deliveryCard.classList.add('dd-envio--dispatch');
      deliveryCard.dataset.ddDispatchReady = 'true';
    });
  }

  function renderDispatchCountdown() {
    const state = dispatchState();
    renderDispatchBanner();
    renderProductDispatch(state);
  }

  function installDispatchCountdown() {
    renderDispatchCountdown();
    window.setInterval(renderDispatchCountdown, 30000);
    document.addEventListener('shopify:section:load', renderDispatchCountdown);
  }

  function readRecentProducts() {
    try {
      const value = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      if (!Array.isArray(value)) return [];
      const cutoff = Date.now() - RECENT_TTL;
      return value
        .filter((item) => item && item.id && item.url && Number(item.seenAt) > cutoff && item.isAdult !== true && item.scope !== 'wholesale')
        .slice(0, RECENT_LIMIT);
    } catch (_error) {
      return [];
    }
  }

  function saveRecentProducts(items) {
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, RECENT_LIMIT)));
    } catch (_error) {
      // Browsing modes that block storage should keep the storefront fully usable.
    }
  }

  function currentProductData() {
    const source = document.querySelector('[data-dd-recent-current]');
    if (!(source instanceof HTMLScriptElement)) return null;
    try {
      return JSON.parse(source.textContent || 'null');
    } catch (_error) {
      return null;
    }
  }

  function safeProductUrl(value) {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      return url.origin === window.location.origin ? url.href : '';
    } catch (_error) {
      return '';
    }
  }

  function recentCard(item) {
    const article = document.createElement('article');
    article.className = 'dd-recently-viewed__card';
    article.setAttribute('role', 'listitem');

    const link = document.createElement('a');
    link.className = 'dd-recently-viewed__link';
    link.href = safeProductUrl(item.url) || '/collections/all';
    link.setAttribute('aria-label', `Volver a ver ${item.title || 'producto'}`);

    const media = document.createElement('span');
    media.className = 'dd-recently-viewed__media';
    if (item.image) {
      const image = document.createElement('img');
      image.src = String(item.image);
      image.alt = String(item.title || 'Producto DeusDream');
      image.loading = 'lazy';
      image.decoding = 'async';
      media.append(image);
    }

    const copy = document.createElement('span');
    copy.className = 'dd-recently-viewed__copy';
    const title = document.createElement('span');
    title.className = 'dd-recently-viewed__title';
    title.textContent = String(item.title || 'Producto DeusDream');
    const price = document.createElement('span');
    price.className = `dd-recently-viewed__price${item.onSale ? ' is-sale' : ''}`;
    price.textContent = String(item.price || 'Ver precio');
    copy.append(title, price);

    if (item.available === false) {
      const status = document.createElement('span');
      status.className = 'dd-recently-viewed__status';
      status.textContent = 'Agotado';
      copy.append(status);
    }

    link.append(media, copy);
    article.append(link);
    return article;
  }

  function installRecentlyViewed() {
    const section = document.querySelector('[data-dd-recently-viewed]');
    if (!(section instanceof HTMLElement)) return;

    const current = currentProductData();
    let items = readRecentProducts();

    if (current && current.id && current.track !== false && current.isAdult !== true && current.scope !== 'wholesale') {
      current.seenAt = Date.now();
      items = [current, ...items.filter((item) => String(item.id) !== String(current.id))].slice(0, RECENT_LIMIT);
      saveRecentProducts(items);
    }

    const currentId = current?.id || section.dataset.currentProductId || '';
    const visible = items.filter((item) => String(item.id) !== String(currentId)).slice(0, RECENT_VISIBLE);
    const track = section.querySelector('[data-dd-recent-track]');
    if (!(track instanceof HTMLElement) || !visible.length) return;

    const fragment = document.createDocumentFragment();
    visible.forEach((item) => fragment.append(recentCard(item)));
    track.replaceChildren(fragment);
    section.hidden = false;
  }

  function updateMobileCartCount(count) {
    const value = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-dd-mobile-cart-count]').forEach((badge) => {
      badge.textContent = value > 99 ? '99+' : String(value);
      badge.hidden = value === 0;
    });
  }

  function installMobileCartCount() {
    document.addEventListener('shopify:cart:lines-update', (event) => {
      const promise = event.promise;
      if (!promise || typeof promise.then !== 'function') return;
      Promise.resolve(promise).then((result) => {
        const count = result?.cart?.totalQuantity ?? result?.detail?.itemCount;
        if (count !== undefined) updateMobileCartCount(count);
      }).catch(() => {});
    });

    document.addEventListener('cart:update', (event) => {
      const count = event.detail?.cart?.item_count ?? event.detail?.itemCount;
      if (count !== undefined) updateMobileCartCount(count);
    });
  }

  function runMicroAnimation(element, className, duration = 560) {
    if (!(element instanceof HTMLElement)) return;
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);

    const cleanup = () => element.classList.remove(className);
    element.addEventListener('animationend', cleanup, { once: true });
    window.setTimeout(cleanup, duration + 120);
  }

  function isWholesaleContext(element) {
    return Boolean(element?.closest?.('.dd-wholesale, .ddwp, [data-dd-wholesale], [data-ddwp-section]'));
  }

  function animateVariantEvent(event) {
    const origin = event.target instanceof Element ? event.target : null;
    if (!origin || isWholesaleContext(origin)) return;

    const picker = origin.closest('variant-picker');
    const selected = picker?.querySelector('input:checked')?.closest('label, .variant-option') || picker || origin;
    const scope = origin.closest('product-card, .product-information, .quick-add-modal, .shopify-section');
    const price = scope?.querySelector('product-price, [data-dd-smart-price], .dd-product-card__price');
    const media = scope?.querySelector('.product-media__image, .dd-product-card__image');

    runMicroAnimation(selected, 'dd-micro-variant-selected', 420);
    runMicroAnimation(price, 'dd-micro-content-change', 420);
    runMicroAnimation(media, 'dd-micro-media-change', 420);
  }

  function installMicroInteractions() {
    let lastAddTrigger = null;
    let addTriggerTimeout = 0;
    let cartUpdateTimeout = 0;
    let shippingWasComplete = Boolean(document.querySelector('.dd-cart-goal__status.is-complete'));

    const rememberAddTrigger = (element) => {
      if (!(element instanceof HTMLElement) || isWholesaleContext(element)) return;
      lastAddTrigger = element;
      runMicroAnimation(element, 'dd-micro-action-press', 260);
      window.clearTimeout(addTriggerTimeout);
      addTriggerTimeout = window.setTimeout(() => {
        lastAddTrigger = null;
      }, 6000);
    };

    document.addEventListener('pointerdown', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const category = target.closest(
        '.dd-category, .dd-collection-carousel__item, .dd-tabbed-products__tab, .dd-header-catalog__item'
      );
      if (category) runMicroAnimation(category, 'dd-micro-category-select', 420);

      const addButton = target.closest(
        'button[name="add"], add-to-cart-component button, [data-dd-smart-add], .dd-product-card__button[type="submit"]'
      );
      if (addButton) rememberAddTrigger(addButton);
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form || isWholesaleContext(form)) return;
      if (!form.matches('form[action*="/cart/add"], product-form-component form, .dd-product-card__form')) return;
      const submitter = event.submitter instanceof HTMLElement
        ? event.submitter
        : form.querySelector('button[type="submit"], button[name="add"]');
      rememberAddTrigger(submitter);
    }, true);

    document.addEventListener('shopify:product:select', animateVariantEvent);
    document.addEventListener('change', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target || isWholesaleContext(target)) return;
      if (!target.matches('[data-dd-smart-variant]')) return;
      animateVariantEvent(event);
    });

    const renderCartMicroState = () => {
      document.querySelectorAll('cart-items-component').forEach((component) => {
        runMicroAnimation(component, 'dd-micro-cart-update', 460);
      });
      document.querySelectorAll('cart-icon, .dd-mobile-nav__link[href*="/cart"]').forEach((cartLink) => {
        runMicroAnimation(cartLink, 'dd-micro-cart-confirm', 520);
      });

      if (lastAddTrigger && document.contains(lastAddTrigger)) {
        runMicroAnimation(lastAddTrigger, 'dd-micro-added', 620);
      }
      lastAddTrigger = null;
      window.clearTimeout(addTriggerTimeout);

      const shippingIsComplete = Boolean(document.querySelector('.dd-cart-goal__status.is-complete'));
      if (!shippingWasComplete && shippingIsComplete) {
        document.querySelectorAll('.dd-cart-goal__status.is-complete').forEach((goal) => {
          runMicroAnimation(goal, 'dd-micro-shipping-complete', 900);
          runMicroAnimation(goal.querySelector('.dd-cart-goal__truck'), 'dd-micro-shipping-truck', 900);
        });
      }
      shippingWasComplete = shippingIsComplete;
    };

    const scheduleCartMicroState = (event) => {
      const schedule = () => {
        window.clearTimeout(cartUpdateTimeout);
        cartUpdateTimeout = window.setTimeout(renderCartMicroState, 150);
      };
      const promise = event?.promise;
      if (promise && typeof promise.then === 'function') {
        Promise.resolve(promise).then(schedule).catch(() => {});
      } else {
        schedule();
      }
    };

    document.addEventListener('shopify:cart:lines-update', scheduleCartMicroState);
    document.addEventListener('cart:update', scheduleCartMicroState);
  }

  ready(() => {
    installVisualVariantControls();
    installDispatchCountdown();
    installRecentlyViewed();
    installMobileCartCount();
    installMicroInteractions();
  });
})();
